"use client";

import { PopoverContextProvider } from "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/7FZLUSKW.js";
import { usePopoverStore } from "../__chunks/CO7ZDQU2.js";
import "../__chunks/B5WJDZ55.js";
import "../__chunks/C76P7QQC.js";
import "../__chunks/CTKPPFRS.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/popover/popover-provider.tsx
import { jsx } from "react/jsx-runtime";
function PopoverProvider() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = usePopoverStore(props);
  return /* @__PURE__ */jsx(PopoverContextProvider, {
    value: store,
    children: props.children
  });
}
export { PopoverProvider };